// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_m7-1";
export var rowFirst = "_m7-3";
export var rowLast = "_m7-5";
export var rowMiddle = "_m7-4";
export var ticketListScroll = "_m7-2";
export var ticketStack = "_m7-0";